import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { homePathForRole } from "@/lib/authRouting";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");

    (async () => {
      if (!sessionId) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        const referralCode = new URLSearchParams(window.location.search).get("ref");
        const headers = { "X-Session-ID": sessionId };
        if (referralCode) headers["X-Referral-Code"] = referralCode;
        const { data } = await api.post("/auth/session", null, { headers });
        setUser(data);
        // Clear the hash before redirect
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Bem-vindo, ${data.name}!`);
        navigate(homePathForRole(data.role), { replace: true, state: { user: data } });
      } catch (err) {
        toast.error(formatApiError(err));
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#09090B] text-zinc-500 font-mono text-sm">
      <div>
        <span className="dot-blink inline-block h-2 w-2 bg-emerald-400 rounded-full mr-2" />
        autenticando via google…
      </div>
    </div>
  );
}
